import { isJSONArray, isJSONRecord, isJSONRef } from './JSONNode.js';
export const mapJSONNode = (json, handlers) => {
    if (isJSONRef(json)) {
        return handlers.ref(json);
    }
    else if (isJSONRecord(json)) {
        return handlers.record(json);
    }
    else if (isJSONArray(json)) {
        return handlers.array(json);
    }
    else {
        return handlers.scalar ? handlers.scalar(json) : json;
    }
};
